import DateTimeDisplay from '../../components/DateTimeDisplay'
import EntityListTemplate from '../../templates/EntityListTemplate'
import { getGridStringOperators } from '@mui/x-data-grid'

const OrganizationsPage = () => {
  const stringOperators = getGridStringOperators().filter(
    (operator) =>
      operator.value === 'contains' ||
      operator.value === 'equals' ||
      operator.value === 'startsWith',
  )
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      type: 'string',
      sortable: true,
      filterable: true,
      filterOperators: stringOperators,
      width: 200,
      flex: 1,
    },
    {
      field: 'address',
      headerName: 'Address',
      type: 'string',
      sortable: false,
      disableColumnMenu: true,
      width: 250,
      flex: 1,
    },
    {
      field: 'phone',
      headerName: 'Phone',
      type: 'string',
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      width: 150,
      flex: 1,
    },
    {
      field: 'createdAt',
      headerName: 'Created Date',
      type: 'string',
      sortable: true,
      filterable: false,
      editable: false,
      width: 180,
      flex: 1,
      renderCell: (params) => {
        const date = new Date(params.value)
        return <DateTimeDisplay date={date} showTime={true} />
      },
    },
  ]

  return (
    <EntityListTemplate
      entityName="organizations"
      columns={columns}
      title="Organizations"
    />
  )
}

export default OrganizationsPage
